import { Layer, Header, kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import SnapshotPane from './SnapshotPane'
import './styles.scss'
import { SnapshotObject } from './types'

type SnapshotComparisonProps = {
  currentSnapshot: SnapshotObject
  onDownloadClick?: (url: string | null) => void
  previousSnapshot: SnapshotObject
  title: string
}

const SnapshotComparison = ({
  currentSnapshot,
  onDownloadClick,
  previousSnapshot,
  title,
}: SnapshotComparisonProps) => (
  <Layer className="snapshot-comparison">
    <Header
      height="large"
      align="fill"
      color="n3"
      className="snapshot-comparison-header"
    >
      <div className={kuiperClassNames('header-title')}>
        {renderIcon('clock', { ariaMode: 'hidden' })}
        <span>{title}</span>
      </div>
    </Header>
    <div className={kuiperClassNames('snapshot-comparison-preview')}>
      <SnapshotPane
        snapshot={previousSnapshot}
        type="before"
        onDownloadClick={onDownloadClick}
      />
      <SnapshotPane
        snapshot={currentSnapshot}
        type="after"
        onDownloadClick={onDownloadClick}
      />
    </div>
  </Layer>
)

export default SnapshotComparison
